import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Customer } from '../models/customer';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';
import { ClassService } from '../rest_services/class.service';
import { CustomersService } from '../rest_services/customers.service';
import { VisitService } from '../rest_services/visit.service';
import { MsSectorService } from '../rest_services/ms-sector.service';
import { SettingsService } from '../rest_services/settings.service';
import * as moment from 'moment'

@Component({
  selector: 'app-my-customers',
  templateUrl: './my-customers.component.html',
  styleUrls: ['./my-customers.component.css']
})
export class MyCustomersComponent implements OnInit, OnDestroy {

  loading_indicator:boolean=true;
  loading_visit:boolean=true;
  customersLoading:boolean=true;

  loadingCustomersIndicators = true;
  custIndicatorsSubscription!: Subscription;
  custIndicators:any;

  newCustomerForm!:FormGroup;
  updateCustomerForm!:FormGroup;

  refSectors:any[]=[];
  refCities:any[]=[];

  addError: string="";

  classesSubscription!: Subscription;
  classes: any;

  role:any=null;
  allCustomers: any[] | undefined = [];

  commercialCustomersSubscription!: Subscription;
  commercialCustomers: any[] | undefined = [];
  comercialCustomersLoading: boolean = false;

  selectedCustomer:any=null;
  selectedCustomerToUpdate:any=null;
  selectedToDelete:any=null;
  selectedToDeleteType!:string;

  loadingAddingCustomer: boolean = false;
  newCustomerRequest:any={};

  updateCustomerRequest:any={};

  indicators:any;
  no_indicators: boolean = false;

  loadingMessages: boolean = false;
  messages:any[]=[];

  searchForm!:FormGroup;
  searchLoading: boolean = false;
  searchSubscription!: Subscription;
  searchedCustomers: any[]=[];

  loadingCustomersVisits = true;
  custVisitsSubscription!: Subscription;
  custVisits: Array<any> = [];
  token : any = '';

  constructor(private fb:FormBuilder,
              private customersService:CustomersService,
              private classService: ClassService,
              private visitService: VisitService,
              private settingsService:SettingsService,
              private msSector : MsSectorService,
              private route:ActivatedRoute,
              private router:Router) {
    this.initForms();
    this.initNewForm();
  }
  mobile:boolean=false;medium:boolean=false;
  ngOnInit(): void {
    this.getConfig();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.getCommercialCustomers();
    this.getIndicators();
    this.getCustomersIndicators();
    this.getSectors();
    this.getCities();
   this.getClasses();
    // this.getAllCustomers();
    
    this.loading_visit=false;
    if(localStorage.getItem("role")!=undefined) {
      this.role = localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role = sessionStorage.getItem("role");
    }
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  initForms(){
    this.searchForm = this.fb.group({
      'social': [''],
      'sector' : [''],
      'city' : [''],
      'classe' : [''],
    });

    this.updateCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : [''],
      'city' : ['', Validators.required],
      'zip' : [''],
      'address' : [''],
      'phone' : [''],
      'skype' : [''],
      'class' : [''],
      'type':['']
    });
  }

  initNewForm(){
    this.newCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : [''],
      'city' : ['', Validators.required],
      'zip' : [''],
      'address' : [''],
      'phone' : [''],
      'skype' : [''],
      'class' : ['']
    });
  }
  
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {        
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
        }
      },
    )  
  }

  getCities(){
    this.newCustomerForm.controls.city.setValue("");
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
        }
      },
    )  
  }

  originalListCustomers:any[]=[];
  filterCustomers(event:any){
    var glob=this;
    if(event!="notAffected"){
      if(event.target.value!="ALL" && event.target.value!="none" && event.target.value!="all"){
        this.commercialCustomers = this.originalListCustomers.filter(customer => customer.customerClass!=undefined && customer.customerClass!.uuid===event.target.value);
      }else {
        if(event.target.value=="all"){
          this.commercialCustomers = this.originalListCustomers;
        }else {
          this.commercialCustomers = this.originalListCustomers.filter(customer => customer.customerClass===undefined );         
        }
      }
    }else {
      this.commercialCustomers = this.originalListCustomers.filter(customer => customer.not_affected );
    }    
    setTimeout(()=>{
      (<any>$("#my-customers-table")).DataTable( {
        data:this.commercialCustomers,
        columns: [
          { data: 'customer_rs', title: 'Client/Prospect' },
          { data: 'customer_sector', title: 'Secteur' },
          { data: 'customer_added_at', title: "Date d'ajout", render: function(data:any, type:any, row:any){
            if(type === "sort" || type === "type"){
                return data;
            }
            return moment(data).format("DD-MM-YYYY");
        }},
          { data: 'customer_cities', title: 'Ville', render: function(data: any){
            if(data!=undefined && data.length>0){
              return data[0].name;
            }else {
              return "Sans ville";
            }
            } 
          },
          { data: 'added_by_me', title: 'Ajouté par', render: function(data:any){
              if(!data){
                return `<span > - - -</span>`;
              }else {
                return `<span><b>Moi</b></span>`;
              }
            } 
          },
          { data: 'customerClass', title: 'Classe', render: function(data:any){
            var classText ="";
              if(data!=undefined && data!=null){
                classText= classText+`<span class="c-p-price-inc" style="font-size: smaller;">
                <b>${data.refClass}</b></span>`;
                if(data.refClass=="Classe A"){
                  classText= classText+`<div class="progress mt-1" style="height: 2px !important;">
                      <div class="progress-bar bg-success"
                          role="progressbar" style="width: 100%"
                          aria-valuenow="75" aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>`;
                }
                if(data.refClass=="Classe B"){
                  classText= classText+`<div class="progress mt-1" style="height: 2px !important;">
                      <div class="progress-bar bg-secondary"
                          role="progressbar" style="width: 100%"
                          aria-valuenow="75" aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>`;
                }
                if(data.refClass=="Classe C"){
                  classText= classText+`<div class="progress mt-1" style="height: 2px !important;">
                      <div class="progress-bar bg-warning"
                          role="progressbar" style="width: 100%"
                          aria-valuenow="75" aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>`;
                }
                if(data.refClass=="Classe D"){
                  classText= classText+`<div class="progress mt-1" style="height: 2px !important;">
                      <div class="progress-bar bg-dark"
                          role="progressbar" style="width: 100%"
                          aria-valuenow="75" aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>`;
                }
              }else {
                classText= classText+` <span class="c-p-price-inc" style="font-size: smaller;">
                  <b>- - -</b></span>`;
              }
              
              return classText;
            }
          },
          { data: null, title: 'Action', render: function(data:any,row:any){
            var actions=`<span class="d-flex">`;
            if(row.added_by_me || glob.role=="adm"){
              actions = actions +
              `<a href="'edit-customer/'${data.customer}" class="mr-2 action_plan_unique"
                title="Modifier le client">
                <i class="flaticon-pencil-1"></i>
              </a>`;
            }
            if(row.added_by_me || glob.role=="adm"){
              actions = actions +
              `<a href="javascript:void(0);"
                data-toggle="modal"
                class="mr-2 action_plan_unique"
                title="Supprimer le client"
                data-target="#deleteCustomer"
                (click)="selectToDelete(${data.customer}, 'commercial');">
                <i class="flaticon-delete"></i></a>`;
            }
            actions = actions +`<a href="javascript:void(0);" data-toggle="modal" data-target="#visitsModal" (click)="selectCustomer(${data.customer}, 'commercial'); getCustomerVisits(${data.customer})"
            class="mr-2 action_plan_unique" title="Voir l'historique des visites du client">
            <i class="flaticon-left-menu"></i></a></span>`;
            return actions;
            } 
          },
        ],
        columnDefs: [{
          "defaultContent": "-",
          "targets": "_all"
        }],
        "destroy":true,
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "iDisplayLength": 25,
        "scrollCollapse": true,
        order: [[4, 'desc']],
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        rowCallback: (row: Node, data: any | Object, index: number) => {
          const self = this;
          // Unbind first in order to avoid any duplicate handler
          // (see https://github.com/l-lin/angular-datatables/issues/87)
          $('td', row).unbind('click');
          $('td', row).bind('click', () => {
          self.selectCustomer(data.customer,"commercial");
          });
          return row;
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                type: 'line',
                width: '60',
                height: '20',
                lineColor: '#1a73e9',
                fillColor: '#c2d5ff',
                spotColor: 'transparent',
                minSpotColor: 'transparent',
                maxSpotColor: 'transparent',
                highlightSpotColor: 'transparent',
                highlightLineColor: 'transparent',
            });
        }
    });
  }, 200);
  }
  countNotAffected:any=0;
  getCommercialCustomers(){
    this.comercialCustomersLoading = true;
    this.commercialCustomersSubscription = this.customersService.getCommercialCustomers().subscribe(
      ( data: ServiceResponse ) => {
        this.comercialCustomersLoading=false;       
        if(data.code=="3c4a33cadc99d89177c0f7e18a2b1bd4"){
          data.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
              (sectorLabel: any) => {
                customer.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });          
          this.commercialCustomers = data.customers.sort((a:any, b:any) => a.customer_rs.toLowerCase() > b.customer_rs.toLowerCase() ? 1 : -1);
          this.originalListCustomers = this.commercialCustomers
          this.countNotAffected = data.customers.filter(customer => customer.not_affected===true ).length;
          var url = this.router.url;
          const decodedURL = decodeURIComponent(url);
          var myurls = decodedURL.split(";cs=");
          var customerId = myurls[1];
          
          if(customerId!="all" && customerId !=""){
            this.selectCustomer(customerId,"commercial");
            
            setTimeout(()=>{
              (<any>$("#ficheModal")).modal('show');
            }, 500);
          }
          setTimeout(()=>{
              (<any>$("#my-customers-table")).DataTable( {
                "destroy":true,
                "pagingType": "full_numbers",
                "scrollX": '400px',
                "iDisplayLength": 25,
                "scrollCollapse": true,
                order: [[4, 'desc']],
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                        type: 'line',
                        width: '60',
                        height: '20',
                        lineColor: '#1a73e9',
                        fillColor: '#c2d5ff',
                        spotColor: 'transparent',
                        minSpotColor: 'transparent',
                        maxSpotColor: 'transparent',
                        highlightSpotColor: 'transparent',
                        highlightLineColor: 'transparent',
                    });
                }
            });
          }, 200);
        }
      },
    )  
  }
  customerVisited:boolean=false;
  checkIfIsVisited(customer:any){
    if(customer.visited){
      this.customerVisited = true;
    }else {
      this.customerVisited = false;
    }
  }
  serchCustomer(){
    this.searchLoading = true;
    let searchValue = this.searchForm.value;

    let customerSearched = new Customer();
    customerSearched.social_reason = searchValue.social;
    customerSearched.customer_sector = searchValue.sector;
    customerSearched.customer_city = searchValue.city;
    customerSearched.customer_class = searchValue.classe;
    
    this.searchSubscription = this.customersService.searchCustomer(customerSearched).subscribe(
      (resp:ServiceResponse) => {
        
        if(resp.code == "41ada51bff1a929b7584e3e9e7f77a53"){
          this.searchLoading = false;
          resp.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
              (sectorLabel: any) => {
                customer.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          this.searchedCustomers = resp.customers;
        }

        this.searchLoading = false;
      },
      (err:Error) => {
        console.log(err);
        this.searchLoading = false;
      }
    );
  }
  getCityNames(customerCities: any) {
    return customerCities.map((city: any) => city.name).join("\n");
  }
  getAllCustomers(){
    this.customersLoading=true;
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        this.customersLoading=false;       
        if(data.code=="a12d89f623abb138ebacc91b3703326a"){
          this.allCustomers = data.customers;
          
          var url = this.router.url;
          const decodedURL = decodeURIComponent(url);
          var myurls = decodedURL.split(";cs=");
          var customerId = myurls[1];
          
          if(customerId!="all" && customerId !=""){
            this.selectCustomer(customerId, "ref");
            
            setTimeout(()=>{
              (<any>$("#ficheModal")).modal('show');
            }, 500);
          }
          setTimeout(()=>{
              (<any>$("#alter_pagination")).DataTable( {
                "destroy":true,
                "pagingType": "full_numbers",
                "scrollX": '400px',
                "iDisplayLength": 25,
                "scrollCollapse": true,
                order: [[4, 'desc']],
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                        type: 'line',
                        width: '60',
                        height: '20',
                        lineColor: '#1a73e9',
                        fillColor: '#c2d5ff',
                        spotColor: 'transparent',
                        minSpotColor: 'transparent',
                        maxSpotColor: 'transparent',
                        highlightSpotColor: 'transparent',
                        highlightLineColor: 'transparent',
                    });
                }
            });
          }, 200);
        }
      },
    )  
  }

  addNewCustomer(){
    var valuesNewCustomerForm = this.newCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesNewCustomerForm.class;
    this.loadingAddingCustomer = true;
    if(this.newCustomerForm.valid){
          this.newCustomerRequest = {
            social_reason:valuesNewCustomerForm.social,
            customer_sector:valuesNewCustomerForm.sector,
            represented_by:valuesNewCustomerForm.agent,
            customer_email:valuesNewCustomerForm.email,
            customer_city:valuesNewCustomerForm.city,
            customer_zip:valuesNewCustomerForm.zip,
            customer_address:valuesNewCustomerForm.address,
            customer_phone: valuesNewCustomerForm.phone,
            customer_skype: valuesNewCustomerForm.skype,
            customer_refClass: customerClass
          };
    }
    this.customersService.newCustomerRequest = this.newCustomerRequest;
          this.customersService.newCustomer();
          this.newCustomerRequest=this.customersService.newCustomerSubject.subscribe(
            ( data: any ) => {
              if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
                this.loadingAddingCustomer = false;
                this.newCustomerForm.reset();
                this.newCustomerForm.controls['sector'].setValue("", {onlySelf: true});
                this.newCustomerForm.controls['city'].setValue("", {onlySelf: true});
                $("#customer_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_added").hide();
                }, 8000);
                this.commercialCustomers?.push(data.customer);
              } else if (data.code=="06c61e9f990cce9353c3064f99f6ec42"){
                this.addError ="Client existe dèja"; 
                this.loadingAddingCustomer = false;
                $("#customer_not_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_not_added").hide();
                }, 8000)
              } else {
                this.addError ="Client non ajouté"; 

                this.loadingAddingCustomer = false;
                $("#customer_not_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_not_added").hide();
                }, 8000);
              }
            },
          )
  }
  getCustomerVisits(uuid:string){
    this.loadingCustomersVisits = true;
    this.custVisitsSubscription = this.visitService.getCustomerVisits(uuid).subscribe(
      (resp: ServiceResponse) => {
        if(resp.code=="1c44d34b762db2c2d2d02fed29651042"){
          this.custVisits = resp.visits.sort((a:any, b:any) => new Date(a.visitPlannedDate).getTime() - new Date(b.visitPlannedDate).getTime());
        }
        this.loadingCustomersVisits = false;
      },
      (err:any) => {
        console.log(err);
        this.loadingCustomersVisits = false;
      }
    );
  }
  selectCustomer(customer:any,type:string){    
    this.selectedCustomer =null;
    if(type=="commercial"){
      this.selectedCustomer = this.commercialCustomers?.find(d => d.customer== customer);
    } else {
      this.selectedCustomer = this.searchedCustomers?.find(d => d.customer== customer);
    }
    const imageDiv = document.getElementById('imageDiv');
    if(imageDiv)imageDiv.innerHTML = '';

    if (this.selectedCustomer.customer_logo) {
      // Convert the base64 logo to a data URL
      const logoDataUrl = 'data:image/*;base64,' + this.selectedCustomer.customer_logo;
      if (imageDiv) {
        // Create an <img> element and set its src attribute
        const imgElement = document.createElement('img');
        imgElement.src = logoDataUrl;
        imgElement.alt = 'Customer Logo';
        imgElement.style.width = '100px';
        imgElement.style.borderRadius= "50%";
        imgElement.style.border = 'solid 5px #bad0c9';
        imageDiv.innerHTML = '';
        imageDiv.appendChild(imgElement);
      }
    }
    this.getConversationAboutCustomer(customer);
  }

  selectCustomerToUpdate(customer:any, type:string){
    this.selectedCustomer =null;
    if(type=="commercial"){
      this.selectedCustomerToUpdate = this.commercialCustomers?.find(d => d.customer== customer);
    } else {
      this.selectedCustomerToUpdate = this.searchedCustomers?.find(d => d.customer== customer);
    }
    this.updateCustomerForm.patchValue({
      'social' : this.selectedCustomerToUpdate?.customer_rs,
      'sector' : this.selectedCustomerToUpdate?.sector,
      'agent' : this.selectedCustomerToUpdate?.customer_agent,
      'email' : this.selectedCustomerToUpdate?.customer_email,
      'city' : this.selectedCustomerToUpdate?.city,
      'zip' : this.selectedCustomerToUpdate?.customer_zip_code,
      'address' : this.selectedCustomerToUpdate?.customer_address,
      'phone' : this.selectedCustomerToUpdate?.customer_phone,
      'skype' : this.selectedCustomerToUpdate?.customer_skype,
      'class' : (this.selectedCustomerToUpdate?.customerClass?.uuid)?(this.selectedCustomerToUpdate?.customerClass?.uuid):null,
      'type' : type
    });
  }
  
  updateCustomer(code:any){
    var valuesUpdateCustomerForm = this.updateCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesUpdateCustomerForm.class;
    this.loadingAddingCustomer = true;
    if(this.updateCustomerForm.valid){
          this.updateCustomerRequest = {
            social_reason:valuesUpdateCustomerForm.social,
            customer_sector:valuesUpdateCustomerForm.sector,
            represented_by:valuesUpdateCustomerForm.agent,
            customer_email:valuesUpdateCustomerForm.email,
            customer_city:valuesUpdateCustomerForm.city,
            customer_zip:valuesUpdateCustomerForm.zip,
            customer_address:valuesUpdateCustomerForm.address,
            customer_phone: valuesUpdateCustomerForm.phone,
            customer_skype: valuesUpdateCustomerForm.skype,
            customer_refClass: customerClass.uuid?customerClass:null
          };
    }
    
    this.customersService.updateCustomerRequest = this.updateCustomerRequest;
    this.customersService.updateCustomer(code);
    this.updateCustomerRequest=this.customersService.updateCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
          this.loadingAddingCustomer = false;
          this.updateCustomerForm.reset();
          this.updateCustomerForm.controls['sector'].setValue("", {onlySelf: true});
          this.updateCustomerForm.controls['city'].setValue("", {onlySelf: true});
          this.updateCustomerForm.controls['class'].setValue("", {onlySelf: true});

          $("#customer_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_updated").hide();
          }, 8000);

          let customerUpdated = data.customer;
          let oldCustomer = this.commercialCustomers?.find(el=>el.customer==code);
          if(oldCustomer) {
            if(oldCustomer.added_by)
            customerUpdated.added_by = oldCustomer.added_by;
            customerUpdated.customer = code;
            if(oldCustomer.customer_added_at)
            customerUpdated.customer_added_at = oldCustomer.customer_added_at;
            let customerIndex = this.commercialCustomers?.findIndex(el=>el.customer==code);
            if(customerIndex){
              (<any>$("#my-customers-table")).DataTable().destroy();
              this.commercialCustomers?.splice(customerIndex,1,customerUpdated);    
              setTimeout(()=>{
                (<any>$("#my-customers-table")).DataTable({
                  "destroy":true,
                  "pagingType": "full_numbers",
                  "scrollY": '2000px',
                  "scrollX": '400px',
                  "iDisplayLength": 25,
                  "scrollCollapse": true,
                  order: [[4, 'desc']],
                  "language": {
                    "sProcessing": "Traitement en cours ...",
                    "sLengthMenu": "Afficher _MENU_ lignes",
                    "sZeroRecords": "Aucun résultat trouvé",
                    "sEmptyTable": "Aucune donnée disponible",
                    "sInfo": "",
                    "sInfoEmpty": "",
                    searchPlaceholder: "Saisir un mot clé",
                    "sInfoFiltered": "",
                    "sInfoPostFix": "",
                    "sSearch": "Rechercher:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Chargement...",
                    "oPaginate": {
                      "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                    },
                    "oAria": {
                      "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                    }
                  },
                  drawCallback: function () {
                    (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                    });
                  }
                });
              }, 200);
            }
          }
          
          let oldCustomerRef = this.searchedCustomers?.find(el=>el.customer==code);
          if(oldCustomerRef){ 
            if(oldCustomerRef.added_by)
            customerUpdated.added_by = oldCustomerRef.added_by;
            customerUpdated.customer = code;
            if(oldCustomerRef.customer_added_at)
            customerUpdated.customer_added_at = oldCustomerRef.customer_added_at;
            let customerRefIndex = this.searchedCustomers?.findIndex(el=>el.customer==code);
            if(customerRefIndex)            
            this.searchedCustomers?.splice(customerRefIndex,1,customerUpdated);
          }

        }else {
          this.loadingAddingCustomer = false;
          $("#customer_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_updated").hide();
          }, 8000);
        }
      },
    )
  }

  selectToDelete(customer:any, type: string){
    this.selectedToDelete = customer.uuid;
    if(customer.visited){
      this.customerVisited = true;
    }else {
      this.customerVisited = false;
    }
    this.selectedToDeleteType = type
  }
  
  deleteCustomer(){
    this.loadingAddingCustomer = true;
    this.customersService.deleteCustomer(this.selectedToDelete);
    this.newCustomerRequest=this.customersService.deleteCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="07eecf57368f24ff98b16f12028ebf14"){
          this.loadingAddingCustomer = false;
          this.newCustomerForm.reset();
          $("#customer_deleted").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_deleted").hide();
          }, 8000);
            let index = this.commercialCustomers?.findIndex(d => d.customer === this.selectedToDelete);
            if(index)
            this.commercialCustomers?.splice(index, 1);
          
            let indexSearched = this.searchedCustomers?.findIndex(d => d.customer === this.selectedToDelete);
            if(indexSearched)
            this.searchedCustomers?.splice(indexSearched, 1);
          
        }else if(data.code=="6df28a63c9c310c55e25d640ae7ee7da"){
          this.loadingAddingCustomer = false;
          $("#customer_not_deleted_have_visits").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_deleted_have_visits").hide();
          }, 8000);
        }else {
          this.loadingAddingCustomer = false;
          $("#customer_not_deleted").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_deleted").hide();
          }, 8000);
        }
      },
    )
  }

  getIndicators(){
    this.customersService.getIndicatorsCustomers();
    this.customersService.indicatorsSubject.subscribe(
      ( data: any ) => {        
        if(data.code=="122da9e5fbdd3f20770a41fd9a7c19cc"){
          this.indicators = data.indicators;
          this.no_indicators = false;
        }else {
          this.no_indicators = true;
        }
        this.loading_indicator=false;
      },
    )  
  }

  getCustomersIndicators(){
    this.custIndicatorsSubscription = this.customersService.getCommercialCustomersIndicators().subscribe(
      ( data: ServiceResponse ) => {        
        if(data.code=="4d7694a6e1cf484173e4728636d51832"){
          this.custIndicators = data.indicators;
        }
        this.loadingCustomersIndicators = false;
      },
    )  
  }

  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.loadingMessages=false;
          this.sending = false;
        },
        error => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }
  selectedClassValue:any;
  selectedClass(classe:any){    
    $('input[name="radio"]').prop('checked', false);
    this.selectedClassValue = classe;
  }
  customersFilterSubscription!: Subscription;
  showCommercials:boolean=false;
  showClasses:boolean=false;
  typeFilter:any;
  getCustomersCritary(critary:any, event:any){
    const items = document.querySelectorAll('.btn-filter');
    this.countNotAffected =0
    if(event!=""){
      if(items.length> 0){
        event.target.classList.add('btn-filter');
        items.forEach((element, index) => {
          if (element !== event.target){
              element.classList.remove('btn-filter');
          }
        });
      }else {
        event.target.classList.add('btn-filter');
      }
    }
    if(critary=="notAffected"){
      // this.showBloc =true;
      // this.customersOfCommercial(critary,null);
      this.showCommercials=false;
    }else if(critary=="all"){
      this.getAllCustomers();
      this.showCommercials=false;
    }else if(critary=="notClassified"){
      this.typeFilter = "NOCLSS";
      // this.showBloc =true;
      // this.customersOfCommercial("", this.typeFilter);
      this.showClasses=false;
      // this.showCommercials=false;
    }else if(critary=="classified"){
      this.typeFilter = "WITHCLSS";
      this.showClasses=true;
      // this.showCommercials=true;
    }else if(critary=="classifiedAffected"){
      this.showCommercials=true;
      this.typeFilter = "WITHCLSS";
    }else {
      this.showCommercials=true;
      this.showClasses=false;
    }
  }
  ngOnDestroy(): void {
    this.commercialCustomersSubscription?.unsubscribe();
    this.classesSubscription?.unsubscribe();
    this.searchSubscription?.unsubscribe();
    this.custIndicatorsSubscription?.unsubscribe();
    this.custVisitsSubscription?.unsubscribe();
  }

}

